/**
 * Joins items into a list in the reader's language, with the locale's own
 * separator rather than a hand-written `', '`.
 *
 * `Intl.ListFormat` with `type: 'conjunction'` is the part that knows a list
 * separator is not universal. `style: 'narrow'` gives a plain enumeration with
 * no "and" — measured on this runtime: `en` and `ru` answer `A, B, C`, `zh`
 * answers `A、B、C`, `ar` answers `A وB وC`. `style: 'long'` is a sentence's
 * list: `en` answers `A, B, and C`. (`type: 'unit'` looks like the right name
 * and is not: it joins `zh` with nothing at all — `ABC` — and `ru` with
 * spaces.)
 *
 * The `catch` is not defensive decoration: `Intl.ListFormat` throws
 * `RangeError` on a malformed language tag, and a caller may run inside a
 * render, where a throw takes the whole grid to the app error boundary. The
 * fallback is the English-shaped join.
 */
export function formatLocaleList(
  items: string[],
  language: string,
  style: 'long' | 'narrow'
): string {
  try {
    return new Intl.ListFormat(language, {
      style,
      type: 'conjunction',
    }).format(items);
  } catch {
    return items.join(', ');
  }
}
